import { splitProps, type ComponentProps, type JSX } from 'solid-js';

export type ButtonVariant = 'primary' | 'secondary' | 'ghost' | 'danger' | 'gradient';
export type ButtonSize = 'sm' | 'md' | 'lg';

interface ButtonProps extends ComponentProps<'button'> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  block?: boolean;
  loading?: boolean;
}

export function buttonClass(variant: ButtonVariant = 'primary', size: ButtonSize = 'md', block = false): string {
  return ['tk-btn', `tk-btn--${variant}`, `tk-btn--${size}`, block ? 'tk-btn--block' : ''].filter(Boolean).join(' ');
}

export function Button(props: ButtonProps): JSX.Element {
  const [local, rest] = splitProps(props, ['variant', 'size', 'block', 'loading', 'class', 'children', 'disabled']);
  return (
    <button
      type="button"
      {...rest}
      disabled={local.disabled || local.loading}
      class={`${buttonClass(local.variant, local.size, local.block)} ${local.class ?? ''}`}
    >
      {local.loading && <span class="tk-spinner" />}
      {local.children}
    </button>
  );
}

export function IconButton(props: ComponentProps<'button'> & { label: string; small?: boolean }): JSX.Element {
  const [local, rest] = splitProps(props, ['label', 'small', 'class', 'children']);
  return (
    <button
      type="button"
      aria-label={local.label}
      title={local.label}
      {...rest}
      class={`tk-icon-btn ${local.small ? 'tk-icon-btn--sm' : ''} ${local.class ?? ''}`}
    >
      {local.children}
    </button>
  );
}
